import { StyleSheet } from 'aphrodite/no-important';
import briefcase from '../../../assets/icons/briefcase.svg';
import dots from '../../../assets/icons/dots_more.svg';
import globe from '../../../assets/icons/globe.svg';
import globeWhite from '../../../assets/icons/globe-white.svg';
import server from '../../../assets/icons/server.svg';
import site from '../../../assets/icons/site.svg';
import tag from '../../../assets/icons/tag.svg';

let styles = {
  base: {
    display: 'block',
    width: 14,
    height: 14,
    padding: 2,
    marginTop: 2,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%'
  },
  tag: {
    backgroundImage: `url(${tag})`
  },
  site: {
    backgroundImage: `url(${site})`
  },
  server: {
    backgroundImage: `url(${server})`
  },
  briefcase: {
    backgroundImage: `url(${briefcase})`
  },
  globe: {
    backgroundImage: `url(${globe})`
  },
  'globe-white': {
    backgroundImage: `url(${globeWhite})`
  },
  dots: {
    backgroundImage: `url(${dots})`
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/svgicon/SvgIcon.styles.js